<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      show-footer
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:batchAmount="{ row }">
        <span>{{ row.v_batchPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:shipmentNo="{ row }">
        <span
          @click="
            openEditPage({
              pageType: 'detail',
              params: { code: row.shipmentCode },
              query: { shipmentNo: row.shipmentNo },
            })
          "
        >
          <el-link type="primary" :underline="false" style="font-size: 14px;">
            {{ row.shipmentNo }}</el-link
          >
        </span>
      </template>
      <template v-slot:batchSalePrice="{ row }">
        <span
          >{{ row.v_batchSalePriceAmount || 0 }}
          {{ row.v_salesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: {},
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {},
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-wait-booking-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
